import React, { useEffect } from "react";
import "./Orders.css";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from "../../store/actions";

import Spinner from "../../containers/UI/Spinner/Spinner";
import { ErrorBoundary } from "../../containers/ErrorBoundary";
import { FaClipboardList } from "react-icons/fa";

// ==============================
// STATUS DISPLAY HELPERS
// ==============================

const STATUS_LABELS = {
  PENDING_CONFIRMATION: "Pending Confirmation",
  CONFIRMED: "Confirmed",
  COLLECTED: "Collected",
  CANCELLED: "Cancelled",
};

const STATUS_CLASS = {
  PENDING_CONFIRMATION: "aggStatus--pending",
  CONFIRMED: "aggStatus--confirmed",
  COLLECTED: "aggStatus--collected",
  CANCELLED: "aggStatus--cancelled",
};

/**
 * Format an ISO date string to DD.MM.YYYY, or return '—' if null.
 */
const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
};

// ==============================
// COMPONENT
// ==============================

const Orders = (props) => {
  const navigate = useNavigate();
  const { loading, orders, error, getAggregatedOrders } = props;

  useEffect(() => {
    getAggregatedOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clickRowHandler = (id) => {
    navigate(`/aggregated-order-details/${id}`);
  };

  if (loading) {
    return (
      <div className="ordersContent">
        <div className="ordersTitle"><span>Your Orders</span></div>
        <Spinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="ordersContent">
        <div className="ordersTitle"><span>Your Orders</span></div>
        <div className="emptyListView">
          <div className="emptyListCircle">
            <FaClipboardList size={80} color="#dcdee3" />
          </div>
          <span>Failed to load orders. Please check your connection and try again.</span>
          <button
            onClick={getAggregatedOrders}
            style={{
              marginTop: "16px",
              padding: "10px 28px",
              background: "transparent linear-gradient(90deg, #FEA80E 0%, #FF6271 100%)",
              border: "none",
              borderRadius: "4px",
              color: "white",
              fontSize: "15px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="ordersContent">
        <div className="ordersTitle">
          <span>Your Orders</span>
        </div>

        <div className="orderFiltersTableBox">
          {orders.length === 0 ? (
            <div className="emptyListView">
              <div className="emptyListCircle">
                <FaClipboardList size={80} color="#dcdee3" />
              </div>
              <span>You currently don&apos;t have any orders.</span>
            </div>
          ) : (
            <div className="aggOrdersTableWrapper">
              <table className="aggOrdersTable">
                <thead>
                  <tr>
                    <th>Order Number</th>
                    <th>Status</th>
                    <th>Total Items</th>
                    <th>Total Amount</th>
                    <th>Cutoff Date</th>
                    <th>Confirmation Deadline</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr
                      key={order.id}
                      className="aggOrdersTableRow"
                      onClick={() => clickRowHandler(order.id)}
                    >
                      <td className="aggOrderNumber">{order.aggregatedOrderNumber}</td>
                      <td>
                        <span className={`aggStatusBadge ${STATUS_CLASS[order.status] || ""}`}>
                          {STATUS_LABELS[order.status] || order.status}
                        </span>
                      </td>
                      <td>{order.itemCount}</td>
                      <td>QAR {Number(order.totalAmount).toFixed(2)}</td>
                      <td>{formatDate(order.cutoffDate)}</td>
                      <td>
                        {order.status === "PENDING_CONFIRMATION"
                          ? formatDate(order.cutoffDate)
                          : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );
};

const mapStateToProps = (state) => ({
  orders: state.orders.orders,
  loading: state.orders.loading,
  error: state.orders.error,
  profile: state.profile.profileDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getAggregatedOrders: () => dispatch(actions.getAggregatedOrders()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Orders);
